import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginActions } from './action/loginAction';
import { withTranslation } from 'react-i18next';
import { appVariables } from './helpers/appVariables';
import { alertActions } from './action/AlertAction';
import Header from './Header/Header';
// import countrycode from './Pages/Home/countrycode.json';
import { history } from './helpers/history';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { commonClass } from './helpers/commonClass';
let CheckMy = false;
let CheckMyWithouthome = false;
let CheckMyOnlyhome = false;
let CheckIsHomePage = true;
class LoginNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNo: '', otp: '', password: '',
            Countrydetails: [], Selcountry: {},
            showpwd: false, TermsAndCond: true,
            Countryfilter: '', Default: {},
            UserCountry: localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {},
            userid: "",
            ErrorMobileNo: "", ErrorPassword: "",
            regUserid: "",
            SwitchControl: false
        }
        this.btnLogin = this.btnLogin.bind(this);
        this.props.logout(this.props.user.mobileNo, 1);
        localStorage.removeItem('coupencode') // after registration complete remove coupen code in localstorage. 
        try {
            let fff1 = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1].toLowerCase();
            let _check = fff1 != 'home' && fff1 != '' && fff1 != 'lottery-ticket' && fff1 != 'big-ticket'
            let fff2 = (window.location.pathname.split('/').length < 2 && fff1.toLowerCase().indexOf('-') >= 0) || fff1.toLowerCase().indexOf('home') >= 0 || fff1.toLowerCase().indexOf('lottery-ticket') >= 0;
            CheckMy = Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my';
            CheckMyWithouthome = CheckMy && !fff2;
            CheckMyOnlyhome = CheckMy && fff2;
            CheckIsHomePage = _check;
        } catch (error) {
        }
    }
    handleInputChange(e) {
        this.setEmptyError()
        const regex = /^[0-9\b]+$/;
        if (regex.test(e.target.value) || e.target.value == '') {
            this.setState({ [e.target.name]: e.target.value });
            this.setState({ regUserid: "" })
        }

    }
    toggleCountry = () => {
        window.setCountryToggle();
    }
    countryChange = (data) => {
        this.setState({ Selcountry: data, mobileNo: '' });
        window.setCountryToggle();
        this.state.Countryfilter = ''
    }



    handleInputChangePwd(e) {
        this.setEmptyError()
        this.setState({ [e.target.name]: e.target.value });
    }
    IsEnterOption = () => {
        if (this.state.regUserid.length > 0) {
            return true;
        }
        else {
            return this.state.mobileNo.length <= this.state.Selcountry.mobNolength && this.state.mobileNo.length >= this.state.Selcountry.mobNoMinlength
        }
    }

    // btnLogin(e) {
    //     e.preventDefault();
    //     if ((this.state.mobileNo && this.state.mobileNo.trim() != "") || (this.state.regUserid && this.state.regUserid.trim() != "")) {
    //         this.setErrorMessage(1, "")
    //         if (this.state.password && this.state.password.trim() != "") {
    //             this.setErrorMessage(2, "")
    //             if (this.IsEnterOption()) {
    //                 this.setErrorMessage(1, "")
    //                 this.state.password = this.state.password.replace(/'/g, "''");
    //                 let _uloc = "";
    //                 try {
    //                     _uloc = localStorage.getItem('cloc');
    //                     _uloc = _uloc ? _uloc : "";
    //                 } catch (error) {
    //                     _uloc = "";
    //                 }
    //                 _uloc = _uloc.replace(/'/g, "''");
    //                 let entryoption = this.state.regUserid.length > 0 ? '0' : this.state.Selcountry.flag;
    //                 let Entrylogin = this.state.regUserid.length > 0 ? this.state.regUserid : this.state.mobileNo;
    //                 this.props.login(Entrylogin, this.state.password, appVariables.LOGIN.Password, this.props.i18n.language, this.props.user.loginKey, entryoption, _uloc);
    //             }
    //             else { this.showMsg('lblValidMobileNo', 1); }
    //         }
    //         else { this.showMsg('lblEnterPwd', 2); }
    //     }
    //     else { this.showMsg('lblentermobileNo', 1); }
    // }

    btnLogin(e) {
        e.preventDefault();
        const { mobileNo, regUserid, password, Selcountry, i18n, user } = this.state;
        const loginKey = this.props.user.loginKey;

        const hasMobile = mobileNo && mobileNo.trim() !== "";
        const hasUserId = regUserid && regUserid.trim() !== "";
        let validationflag = true
        // Check for mobile number or user ID
        if (!hasMobile && !hasUserId) {
            this.showMsg('lblentermobileNo', 1);
            validationflag = false;
        }
        if (!this.IsEnterOption() && validationflag) {
            this.showMsg('lblValidMobileNo', 1);
            validationflag = false;
        }
        // Password check
        if (!password || password.trim() === "") {
            this.showMsg('lblEnterPwd', 2);
            validationflag = false;
        }
        // Mobile number format validation (if logging in with mobile)

        if (validationflag) {
            // Sanitize password
            const sanitizedPassword = password.replace(/'/g, "''");
            // Get location from local storage
            let _uloc = "";
            try {
                _uloc = localStorage.getItem('cloc') || "";
            } catch {
                _uloc = "";
            }
            _uloc = _uloc.replace(/'/g, "''");
            const isUsingUserId = regUserid && regUserid.length > 0;
            const entryoption = isUsingUserId ? '0' : Selcountry.flag;
            const Entrylogin = isUsingUserId ? regUserid : mobileNo;
            // Call login
            this.props.login(
                Entrylogin,
                sanitizedPassword,
                appVariables.LOGIN.Password,
                this.props.i18n.language,
                loginKey,
                entryoption,
                _uloc
            );
        }
    }


    static getDerivedStateFromProps(props, state) {
        return { otp: props.otp };
    };
    componentDidUpdate(prevState, prevProps) {

        // if (this.props.otp && this.props.otp.otp && (prevProps.otp == null || prevProps.otp.mobileNo != this.props.otp.mobileNo)) {
        //     this.showMsg(this.props.otp.otp);
        // }
    }
    componentDidMount(prevState, prevProps) {
        if (window.LoginOverlay) {
            window.LoginOverlay()
        }
        this.GetCountryList()
        // First time not set default URL.
        // setTimeout(() => {
        //     this.GetUserCountry()
        // }, 300);
        let mythis = this;
        mythis.setjsondata();
        //setTimeout(() => { mythis.setjsondata(1); }, 2000)//700
    }
    setjsondata = (isdelay = 0) => {
        try {
            if (CheckMyWithouthome) {
                return
            }
            let hbanner = 0;
            let hbanner_old = localStorage.getItem('whbvers');
            if (this.props.appvariables.bVersion) {
                let hbannerVer = this.props.appvariables.bVersion.split("~")
                if (hbannerVer.length > 0) {
                    hbanner = hbannerVer[7];
                }
            }
            let temp_hbanner = false;
            let _test = JSON.parse(localStorage.getItem('whbLoglst'));
            if (_test && !_test.data) {
                localStorage.removeItem('whbLoglst');
                temp_hbanner = true;
            }
            let HomebannerJson = [];
            if (hbanner_old != hbanner || temp_hbanner) { // hbanner_old != hbannertrue
                var s = process.env.REACT_APP_CDN_URL + 'Web/WEBLogin.json' + "?V" + hbanner;
                fetch(s).then(response => response.json()).then(data => {
                    localStorage.setItem('whbLoglst', JSON.stringify(data)); // set ftb all Array 
                    let dg = setInterval(() => {
                        if (this.props.serverTime > 0) {
                            clearInterval(dg);
                            HomebannerJson = this.Formbannerimage(data);          //form banner image
                            this.SetgetJsonbanner(HomebannerJson);                     //set banner image for state
                            localStorage.setItem('whbvers', hbanner);
                        }
                    }, 1);
                })
            } else {
                if (isdelay == 0) {
                    let BannerimgLcl = JSON.parse(localStorage.getItem('whbLoglst')); // get ftb all Array
                    let dg1 = setInterval(() => {
                        if (this.props.serverTime > 0) {
                            clearInterval(dg1);
                            HomebannerJson = this.Formbannerimage(BannerimgLcl);           //form banner image
                            this.SetgetJsonbanner(HomebannerJson);                         //set banner image for state
                        }
                    })
                }
            }
        }
        catch (ex) {
            console.log("setjsondata => ", ex)
        }
    };
    Formbannerimage = (data) => {
        try {
            const mythis = this;
            let HomebannerJsonObj = [];
            let getcountry = localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {}
            const AllCountry = localStorage.getItem('countrylst') ? JSON.parse(localStorage.getItem('countrylst')) : [];
            data.data.forEach(obj => {
                if (obj) {
                    let startdate = obj.startDate;
                    var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                    let strmilliseconds = (new Date(startdate.replace(pattern, '$3-$2-$1').replace(/-/g, '/')).getTime());
                    if (mythis.props.serverTime >= strmilliseconds) {
                        if (obj.expiryDate != "" && obj.expiryDate != "null") {
                            let enddate = obj.expiryDate;
                            var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                            let endmilliseconds = (new Date(enddate.replace(pattern, '$3-$2-$1').replace(/-/g, '/')).getTime());
                            if (mythis.props.serverTime < endmilliseconds) {
                                let bannerobj = this.formBannerObj(obj, data, getcountry, AllCountry);
                                if (bannerobj) {
                                    HomebannerJsonObj.push(bannerobj);
                                }
                            }
                        }
                        else {
                            let bannerobj = this.formBannerObj(obj, data, getcountry, AllCountry);
                            if (bannerobj) {
                                HomebannerJsonObj.push(bannerobj);
                            }
                        };
                    }
                }
            });
            return HomebannerJsonObj;
        }
        catch (ex) {
            console.log("Formbannerimage => ", ex)
        }
    }
    formBannerObj = (obj, data, getcountry, AllCountry) => {
        try {
            obj.imagPath = data.baseurl ? data.baseurl + obj.imagPath : obj.imagPath;
            // let getcountry = localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {}
            // const AllCountry = localStorage.getItem('countrylst') ? JSON.parse(localStorage.getItem('countrylst')) : [];

            let getAll_c_list = AllCountry.other && AllCountry.other.length > 0 ? AllCountry.other.filter(a => a.isocode2 == getcountry.country) : [];
            if (!getAll_c_list || getAll_c_list.length <= 0) {
                return obj;
            }
            else if (obj.countrycode && obj.countrycode != "0" && obj.countrycode != "") {
                let ShowCountry_list = obj.countrycode.split(',');
                let isvalidcountry = ShowCountry_list.filter(a => a == getAll_c_list[0].flag);
                if (isvalidcountry && isvalidcountry.length > 0) {
                    return obj;
                }
            }
            else {
                let RestrictCountry_list = obj.restrict_country && obj.restrict_country.split(',').length > 0 ? obj.restrict_country.split(',') : [];
                let Checkisallow = RestrictCountry_list && RestrictCountry_list.length > 0 ? RestrictCountry_list.filter(a => a == getAll_c_list[0].flag) : []
                if (Checkisallow && Checkisallow.length > 0) {
                    return null;
                }
                else {
                    return obj;
                }
            }
        } catch (error) {
            console.log("formBannerObj ==> ", error)
            return obj;
        }
    }
    SetgetJsonbanner = (HomebannerJson) => {
        try {
            let numAscending = HomebannerJson.sort(function (a, b) {
                return a.position - b.position || b.modifyOn - a.modifyOn;
            });
            //     this.setState({ bannerList: numAscending });
            //   setTimeout(() => {
            //     window.documentReadyjQueryFlex();
            //     }, 600); 

            let dd = "";
            numAscending.forEach(x => {
                dd += `<img src='${x.imagPath + '?' + x.version}' data-lnk='${x.linkUrl}' alt='Slider Image'/> `
                /* dd += `<li ><img src='${'./assets/img/banner/banner-1.png'}' data-lnk='${x.linkUrl}' alt='Slider Image'/> 
                      <div class='overlay'><div class="overlayCont"> <h1>Total Winners<br>335,323 </h1> <a class="playNowBtn" href="">Buy Now</a> </div></div></li>`; */
            });
            document.getElementById('LoginLftImg').innerHTML = "" + dd + "";
            document.getElementById('HomeslideChild').addEventListener("click", this.bnrClck);
            window.documentReadyjQueryFlex();
        }
        catch (ex) {
            console.log("SetgetJsonbanner => ", ex)
        }
    }

    setEmptyError = () => {
        this.setState({ ErrorMobileNo: "" })
        this.setState({ ErrorPassword: "" })
    }

    setErrorMessage = (flagNo, errorstring) => {
        switch (flagNo) {
            case 1:
                this.setState({ ErrorMobileNo: errorstring })
                break;
            case 2:
                this.setState({ ErrorPassword: errorstring })
                break;
            default:
                break;
        }
    }
    showMsg = (msg, flagNo) => {
        let errorstring = this.props.t(msg)
        if (flagNo > 0) {
            this.setErrorMessage(flagNo, errorstring)
        }
        else {
            this.props.alertError(errorstring);
        }
    }

    handleChange = (e) => {
        this.setEmptyError()
        e.preventDefault()
        if (e.target.name == "regUserid") {
            this.setState({ mobileNo: "" })
        }
        let name = e.target.name;
        this.setState({ [name]: e.target.value })
        this.state.Countryfilter = e.target.value;
    }

    GetCountryList = () => {
        let new_Version = 0;
        let Version_old = localStorage.getItem('countryver');
        if (this.props.appvariables.bVersion) {
            let totalversion = this.props.appvariables.bVersion.split("~")
            if (totalversion.length > 0) {
                new_Version = totalversion[3];
            }
        }
        if (Version_old != new_Version) {
            commonClass.GetCountry(new_Version)
                .then(response =>
                    response.json()
                )
                .then(data => {
                    localStorage.setItem('countryver', new_Version);
                    localStorage.setItem('countrylst', JSON.stringify(data));
                    this.setState({ Countrydetails: data })
                    // this.setState({ Selcountry: data.default })
                    this.setState({ Default: data.default })
                    setTimeout(() => {
                        this.GetUserCountry()
                    }, 300);
                });
        }
        else {
            let CountryList = JSON.parse(localStorage.getItem('countrylst')); // get from localstorage for countrylist
            this.setState({ Countrydetails: CountryList })
            // this.setState({ Selcountry: CountryList.default })
            this.setState({ Default: CountryList.default })
            setTimeout(() => {
                this.GetUserCountry()
            }, 300);
        }
    }

    GetUserCountry = () => {
        let mythis = this;
        try {
            commonClass.GetUserCountry()
                .then(response =>
                    response.json()
                )
                .then(data => {
                    if (data) {
                        let LoadCountry = this.state.Countrydetails.other.filter(Fobj => Fobj.isocode2 == data.country)
                        if (LoadCountry && LoadCountry.length > 0) {
                            this.setState({ Selcountry: LoadCountry[0] });
                        }
                        else {
                            this.setState({ Selcountry: this.state.Default })
                        }
                        localStorage.setItem('cloc', JSON.stringify(data));
                    }
                    else {
                        this.setState({ Selcountry: this.state.Default })
                    }
                }).catch(function (err) {
                    mythis.setState({ Selcountry: mythis.state.Default })
                });
        } catch (error) {
            mythis.setState({ Selcountry: mythis.state.Default })
        }
    }

    HandleCheckBox = (e) => {
        this.setState({ SwitchControl: e.target.checked })
        if (e.target.checked == false) {
            this.setState({ mobileNo: "" })
        }
    }



    render() {
        const { t } = this.props;
        let IsErrorMobileNo = this.state.ErrorMobileNo.length > 0;
        let IsErrorPassword = this.state.ErrorPassword.length > 0;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket - Login</title>
                    <meta name="description" content="Securely Access Your Gulf Ticket Account: Login Now" />
                    <meta name="keywords" content="Gulf Ticket, online raffle draw, Biggest Online Draw" />

                    <meta property="og:title" content="Gulf Ticket - Login" />
                    <meta property="og:site_name" content="Gulf Ticket" />
                    <meta property="og:url" content="https://gulfticket.com" />
                    <meta property="og:description" content="Securely Access Your Gulf Ticket Account: Login Now" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                </Helmet>}
                <div class="signInBox" id='signInBox' style={{ display: "block" }}>
                    <div class="signInBoxWrap" >
                        <div class="signBoxLft" id='LoginLftImg'>

                        </div>
                        {/* <div class="signBoxLft" >
                            <img src="./assets/img/sign-lft.png" />
                        </div> */}
                        <div class="signBoxRht">
                            <div class="userContent">
                                <a class="lightBoxClose"  ><img src="./assets/img/icons/pop_close.png" /></a>
                                <h1>{t('lblLogin')}</h1>

                                <div class="loginSelHead">
                                    <h2 className={`${this.state.SwitchControl == false ? 'bold' : ''}`}>{t('lblMobileNo')}</h2>
                                    <div class="loginSelTabs">
                                        <label for="switchL" class="switchbtn">
                                            <input type="checkbox" id="switchL" name='SwitchControl' checked={this.state.SwitchControl} value={!this.state.SwitchControl} onChange={(e) => { this.HandleCheckBox(e) }} />
                                            <span class="sliderbtn"></span>
                                        </label>
                                        <p className={`${this.state.SwitchControl == true ? 'bold' : ''}`}>{t('lbluserid')}</p>
                                    </div>
                                </div>

                                <form class="register-form paddTop-20" onSubmit={this.btnLogin}>
                                    <>
                                        {this.state.SwitchControl == false ?
                                            <div class="formCont">
                                                <label>{t('lblMobileNo')}<sup>*</sup></label>
                                                <div className={`countryCodes ${IsErrorMobileNo ? "errorBorder bor-right-none" : ""}`}>
                                                    <>
                                                        {this.state.Selcountry && this.state.Selcountry.flag &&
                                                            <a className="countryImg" onClick={() => this.toggleCountry()}>
                                                                <img src={`${process.env.REACT_APP_CDN_URL}/assets/flags/${this.state.Selcountry.flag}.png?v0`} alt={this.state.Selcountry.code} />
                                                                <small>{this.state.Selcountry.code}</small>
                                                            </a>}

                                                        <ul id='selContry' className="selContry scrollbar" style={{ display: "none" }}>
                                                            <li><input style={{ padding: "5px 10px", margin: "5px", height: "35px" }} type="text" value={this.state.Countryfilter} name="Countryfilter" placeholder="Search" onChange={(e) => { this.handleChange(e) }} /></li>
                                                            {this.state.Countrydetails && this.state.Countrydetails.other && this.state.Countrydetails.other.filter(country =>
                                                                (country.Countryname.includes(this.state.Countryfilter.toUpperCase()) || country.flag.includes(this.state.Countryfilter))).map((data, inx) =>
                                                                    <li key={`n_${inx}`}><a onClick={() => this.countryChange(data)}><img src={`${process.env.REACT_APP_CDN_URL}/assets/flags/${data.flag}.png?v0`} alt='Show Flag Icon' />{data.code}</a></li>
                                                                )}
                                                        </ul>
                                                    </>
                                                </div>
                                                {this.state.Selcountry && <input type='tel' className={`inputMobile ${IsErrorMobileNo ? "errorBorder" : ""}`} name='mobileNo' placeholder={`${t('lblMobileNo')}*`} value={this.state.mobileNo} onChange={this.handleInputChange.bind(this)}
                                                    maxLength={this.state.Selcountry.mobNolength} autocomplete="off" ></input>}
                                                {IsErrorMobileNo && <div class="errorTxt">{this.state.ErrorMobileNo}</div>}
                                            </div> :
                                            <div class="formCont">
                                                <label>{t('lbluserid')}<sup>*</sup></label>
                                                <input className={`${IsErrorMobileNo ? "errorBorder" : ""}`} type="text" placeholder="Login With UserID" value={this.state.regUserid} name='regUserid' onChange={(e) => { this.handleChange(e) }} maxLength={15} autocomplete="off" />
                                                {IsErrorMobileNo && <div class="errorTxt">{this.state.ErrorMobileNo}</div>}
                                            </div>

                                        }
                                    </>
                                    <div className='formCont'>
                                        <label>{t('lblPwd')}<sup>*</sup></label>
                                        {/* {this.state.showpwd ?  
                                            <img src="./assets/img/icons/eyeopen.webp?ver=1.0" alt="show password icon" className="passwordEye" onClick={() => this.setState({ showpwd: false })} />
                                            : <img src="./assets/img/icons/eye-slash.webp?ver=1.0" alt="show password icon" className="passwordEye" onClick={() => this.setState({ showpwd: true })} />} {`${t('lblPwd')}*`}*/}
                                        <input className={`${IsErrorPassword ? "errorBorder" : "font-size"}`} type={this.state.showpwd ? "text" : "password"} name='password' placeholder="********" value={this.state.password} maxLength={20} onChange={this.handleInputChangePwd.bind(this)} autocomplete="off" ></input>
                                        {IsErrorPassword && <div class="errorTxt">{this.state.ErrorPassword}</div>}
                                        {this.state.showpwd ? <small id="eyeIcon" class="eyeIcon eyeOpen" onClick={() => this.setState({ showpwd: false })}></small>
                                            : <small id="eyeIcon" class="eyeIcon eyeClose" onClick={() => this.setState({ showpwd: true })} ></small>}
                                    </div>
                                    <span class="frgetPsw" onClick={() => { this.props.getflag(1) }}>{t('lblforgotPwd')} ?</span>
                                    <div class="formCont">
                                        <button type="submit">{t('lblLogin')}</button>
                                    </div>
                                </form>
                                <span class="agree">{t('lblNewSignUpLink')}<a onClick={() => { history.push('/register') }}  >&nbsp;&nbsp;&nbsp;{t('lblRegisternow')}</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overlayLogin" style={{ display: "block" }}></div>
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, otp, appvariables } = state.loginReducer;
    const { serverTime } = state.commonReducer;
    return { user, otp, appvariables, serverTime };
}
const mapActionToProps = {
    login: loginActions.login,
    setPage: loginActions.setPage,
    Otpgen: loginActions.lfnotpgen,
    alertError: alertActions.error,
    logout: loginActions.logout,
    //alertsucc: alertActions.success
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(LoginNew))